/**
 * usps domain — /usps/{address,city-state,zipcode}.
 *
 * Legacy SPFx used `?code=` query for auth on these — v3 api-client strictly
 * uses `x-functions-key` header. Bible §3.0 rule #5.
 */

import type {
  RequestOptions,
  UspsAddressQuery,
  UspsAddressResponse,
  UspsCityStateResponse,
  UspsZipQuery,
  UspsZipResponse,
} from '@retail-ops/shared-types';
import type { ApiHttpClient } from '../http.js';

function queryFromObj(obj: Record<string, unknown>): Record<string, string | number | undefined> {
  const out: Record<string, string | number | undefined> = {};
  for (const [k, v] of Object.entries(obj)) {
    if (v === undefined || v === null) continue;
    out[k] = typeof v === 'number' ? v : String(v);
  }
  return out;
}

export class UspsApi {
  public constructor(private readonly http: ApiHttpClient) {}

  public address(query: UspsAddressQuery, opts?: RequestOptions): Promise<UspsAddressResponse> {
    return this.http.get<UspsAddressResponse>('/usps/address', {
      ...opts,
      query: queryFromObj(query as unknown as Record<string, unknown>),
    });
  }

  public cityState(zipCode: string, opts?: RequestOptions): Promise<UspsCityStateResponse> {
    return this.http.get<UspsCityStateResponse>('/usps/city-state', {
      ...opts,
      query: { ZIPCode: zipCode },
    });
  }

  public zipcode(query: UspsZipQuery, opts?: RequestOptions): Promise<UspsZipResponse> {
    return this.http.get<UspsZipResponse>('/usps/zipcode', {
      ...opts,
      query: queryFromObj(query as unknown as Record<string, unknown>),
    });
  }
}
